import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IReceipt } from "src/domain/entities"
import { ReceiptListView } from "."

interface Props {
	list: IReceipt[]
	isLoading: boolean
	onUpdate: (receipt: IReceipt) => void
	onDelete: (receipt: IReceipt) => void
	onAddClick: () => void
}

export const ReceiptListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No receipts found." onAddClick={onAddClick} />
	}

	return <ReceiptListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
